﻿import Dialog from '../core/Dialog';
import { createButton } from './dialogCommonApi';
import getResource from '../core/resources';

const { wire, bind } = HyperHTMLElement;
function promptModule(
	label = getResource('common.prompt_label'),
	options = {}
) {
	const {
		cancelButtonModifier,
		okButtonModifier,
		title = getResource('common.prompt_title'),
		required = false,
		pattern = null
	} = options;
	const cssClassName = 'aras-dialog-prompt';
	const promptDialog = new Dialog('html', {
		classList: cssClassName,
		title
	});
	const okBtnClassList =
		okButtonModifier || 'aras-button_primary aras-buttons-bar__button';
	const okBtn = createButton(getResource('common.ok'), okBtnClassList, () =>
		promptDialog.close(input.value)
	);
	const cancelBtnClassList =
		cancelButtonModifier || 'aras-button_secondary-light';
	const cancelBtn = createButton(
		getResource('common.cancel'),
		cancelBtnClassList,
		() => promptDialog.close(null)
	);
	const checkValidity = () => {
		if (required || pattern) {
			okBtn.disabled = !input.validity.valid;
		}
	};
	const onInput = required || pattern ? checkValidity : null;
	const labelClass = `${cssClassName}__label`;
	const inputClass = `${cssClassName}__input aras-input`;
	const input = wire()`<input 
		class="${inputClass}" 
		pattern="${pattern}" 
		onInput="${onInput}" 
		required="${required}" 
		autofocus>`;
	bind(promptDialog.contentNode)`
		<label class="${labelClass}">${label}${input}</label>
		<div class="aras-buttons-bar aras-buttons-bar_right">
			${okBtn}${cancelBtn}
		</div>
	`;
	checkValidity();

	promptDialog.show();
	return promptDialog.promise;
}

export default promptModule;
